import React, { useState } from "react";
import {
  Box,
  Modal,
  Typography,
  Checkbox,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { exportHistoryData } from "../../src/utils/generate-history-report";

export default function ExportHistoryModal({ isOpen, onClose, data }) {
  const initialFields = {
    action: false,
    actionBy: false,
    role: false,
    tab: false,
    status: false,
    createdAt: false,
  };

  const [selectedFields, setSelectedFields] = useState(initialFields);
  const [exportType, setExportType] = useState("PDF");

  const handleFieldChange = (field) => {
    setSelectedFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSelectAll = () => {
    const allSelected = Object.values(selectedFields).every(Boolean);
    const newFields = Object.fromEntries(
      Object.keys(selectedFields)?.map((key) => [key, !allSelected])
    );
    setSelectedFields(newFields);
  };

  const handleExport = () => {
    const exportable = data?.map((item) => ({
      ...item.data,
      actionBy: item.data?.actionBy?.firstName
        ? `${item.data.actionBy.firstName} ${item.data.actionBy.lastName}`
        : "System",
      createdAt: new Date(item.data.createdAt).toLocaleString(),
    }));
    exportHistoryData(exportable, selectedFields, exportType);
    onClose();
    setSelectedFields(initialFields); // Reset after export
  };

  const isGenerateDisabled = !Object.values(selectedFields).some(Boolean);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          p: 4,
          borderRadius: 2,
          width: "100%",
          maxWidth: 500,
        }}
      >
        <Typography variant="h6" mb={2}>
          Select Columns to Export
        </Typography>

        <Button
          variant="outlined"
          fullWidth
          onClick={handleSelectAll}
          sx={{ mb: 2 }}
        >
          {Object.values(selectedFields).every(Boolean)
            ? "Unselect All"
            : "Select All"}
        </Button>

        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={1} mb={3}>
          {Object.keys(selectedFields)?.map((field) => (
            <Box key={field} display="flex" alignItems="center">
              <Checkbox
                checked={selectedFields[field]}
                onChange={() => handleFieldChange(field)}
              />
              <Typography>{field.charAt(0).toUpperCase() + field.slice(1)}</Typography>
            </Box>
          ))}
        </Box>

        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="export-type-label">Export Format</InputLabel>
          <Select
            labelId="export-type-label"
            value={exportType}
            onChange={(e) => setExportType(e.target.value)}
            label="Export Format"
          >
            <MenuItem value="PDF">PDF</MenuItem>
            <MenuItem value="Excel">Excel</MenuItem>
          </Select>
        </FormControl>

        <Box display="flex" justifyContent="flex-end" gap={1}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleExport}
            variant="contained"
            disabled={isGenerateDisabled}
          >
            Generate
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
